jQuery(document).ready(function( $ ) {
  let mobile = window.matchMedia("(max-width: 767px), screen and (max-width: 812px) and (orientation: landscape)");
  let mobileOnlyVersion = document.querySelector('.section--fullpage-mobile');
  function fade(element) {
    const index = element.data('reference');
    element.addClass('active');
    element.siblings().removeClass('active');
    $('.article--history:not([style*="display: none"])').fadeOut(250, function () {
      $('.article--history--index' + index).fadeIn(250);
    });
  }
  let counter = 0;
  let interval3000;
  if(!mobile.matches && !mobileOnlyVersion) {
    interval3000 = setInterval(function () {
      if(mobile.matches || mobileOnlyVersion) {
        return;
      }
      counter++;
      if(!$(".article__label")[counter]) {
        counter = 0;
      }
      fade($($(".article__label")[counter]))
    }, 5000);
  }

  $(".article__label").click(function () {
    fade($(this));
    clearInterval(interval3000);
  });

  const slider = document.querySelector('.history-preview__articles');
  const slides = Array.from(document.querySelectorAll('.history-preview__article'));
  const firstSlide = slides[0];

  const dragListeners = {};
  let touchStartX;
  let touchStartY;
  let deltaX;
  let deltaY;
  let scrollingChecked;
  let dirty = false;

  function getActiveSlide() /*: number */ {
    return counter;
  }

  function setActiveSlide(slideIndex /*: number */) {
    counter = slideIndex;

    if(!dirty) {
      $('.history-preview__swipe-indicator').fadeOut();
      dirty = true;
    }
  }

  function calculateTransform() {
    slides.forEach((slide) => {
      slide.style.transform = `translate3d(${counter * -100}%, 0, 0)`;
      slide.style.transition = ``;
    });

    const labelWrapper = $('.article__label-wrapper--'+counter);
    const label = $('.article__label--'+counter);

    $('.article__label').removeClass('active');
    $('.article__label-wrapper').removeClass('active');
    label.addClass('active');
    labelWrapper.addClass('active')

    let lol = Math.max( - ($('.history-preview__mobile-timeline').width() - firstSlide.clientWidth),
        - labelWrapper.position().left + firstSlide.clientWidth / 2);

    $('.history-preview__mobile-timeline').css('transform', `translate3d(${ Math.min(0, lol) }px, 0, 0)`);
  }

  function onTouchstart(event) {
    const touch = event.touches ? event.touches[0] : event;
    touchStartX = touch.pageX;
    touchStartY = touch.pageY;
    deltaX = 0;
    deltaY = 0;
    scrollingChecked = false;

    // Add event listeners needed during drag
    Object.keys(dragListeners).forEach(eventName =>
      slider.addEventListener(eventName, dragListeners[eventName]));
  }

  function onTouchmove(event) {
    const touch = event.touches ? event.touches[0] : event;
    deltaX = touch.pageX - touchStartX;
    deltaY = touch.pageY - touchStartY;

    if (!scrollingChecked) {
      scrollingChecked = true;
      if (Math.abs(deltaX) < Math.abs(deltaY)) {
        Object.keys(dragListeners).forEach(eventName =>
          slider.removeEventListener(eventName, dragListeners[eventName]));

        return;
      }

      slider.classList.add('moving');

      // Disable transitions during swiping
      slides.forEach((slide) => {
        slide.style.transition = 'none';
      });
    }

    event.preventDefault();

    const offset = Math.max(0, Math.min(
      slides.length - (firstSlide.parentNode.clientWidth / firstSlide.offsetWidth),
      getActiveSlide() + (deltaX / -firstSlide.offsetWidth)
    ));

    slides.forEach((slide) => {
      slide.style.transform = `translate3d(${firstSlide.offsetWidth * -offset}px, 0, 0)`;
    });
  }

  dragListeners.touchmove = onTouchmove;

  function onTouchend() {
    const perPage = Math.round(firstSlide.parentNode.clientWidth / firstSlide.offsetWidth);

    if (Math.abs(deltaX) > firstSlide.offsetWidth / 4) {
      const active = getActiveSlide();
      const next = Math.max(0, Math.min(slides.length - perPage, deltaX > 0
        ? active - (active % perPage || perPage) // Next page to the left
        : active - ((active % perPage) + perPage))); // Next page to the right
      if(deltaX > 0) {
        setActiveSlide(Math.max(0, active - 1));
      } else {
        setActiveSlide(Math.min(slides.length - 1, active + 1));
      }
    }
    calculateTransform();

    slider.classList.remove('moving');

    // Remove event listeners that are only needed during drag
    Object.keys(dragListeners).forEach(eventName =>
      slider.removeEventListener(eventName, dragListeners[eventName]));
  }

  dragListeners.touchend = onTouchend;

  if(slider && mobile.matches) {
    slider.addEventListener('touchstart', onTouchstart);
  }
});
